export default "__VITE_ASSET__BmAAF7Ha__"